let workerURL = require('./helpers/get-worker-url');
let bundleURL = require('./helpers/bundle-url');
let url = bundleURL.getBundleURL('9hP3g') + "worker.801e2176.js";module.exports = workerURL(url, bundleURL.getOrigin(url), true);